export default {
  orange: '#F5A827',
};
